
//........................................ UI Modules.....................................................
import lookups from "./modules/lookups";
import security from "./modules/security";
import dashboard from './modules/dashboard';
import workDaysClosing from './modules/workDaysClosing';
//........................................  patients OP.....................................................
import patients from './modules/patients';
import patientsProcedures from './modules/patientsProcedures';
import appointments from './modules/appointments';
import treasury from './modules/treasury';
import doctorsAppointments from './modules/doctorsAppointments';
import invoices from './modules/invoices';
import invoicesAnalysis from './modules/invoicesAnalysis';
//........................................  Setting .....................................................
import departments from './modules/departments';
import reasons from './modules/reviewsReasons';
import doctors from './modules/doctors';
import instructions from './modules/instructions';
import paymentAccounts from './modules/paymentAccounts';

import services from './modules/services';
import users from './modules/users';
import specializations from './modules/specializations';
import employees from './modules/employees';
import analysis from './modules/analysis';
//........................................  inventory Management .....................................................
import medicines from './modules/medicines';
import inventory from './modules/inventory';
import purchaseOrders from './modules/purchaseOrders';
import suppliers from './modules/suppliers';
import stockTransfers from './modules/stockTransfers';
import dispenseRequests from './modules/dispenseRequests';
import doctorPrescriptions from './modules/doctorPrescriptions';
import pharmacy from './modules/pharmacy';
import salaryDoctorsReport from './modules/salaryDoctorsReport';
import bookPatients from './modules/bookPatients';
import doctorsStock from './modules/doctorsStock.js';


export default {
    security,
    lookups,
    dashboard,
    workDaysClosing,
    //..  patients OP ..//
    
    patients,
    invoicesAnalysis,
    patientsProcedures,
    appointments,
    treasury,
    invoices,
    doctorsAppointments,
    //..  setting  ..//
    users,
    reasons,
    departments,
    doctors,
    employees,
    instructions,
    analysis,
    services,
    specializations,
    paymentAccounts,
    doctorsStock,
        //..  inventory Management ...............

    medicines,
    inventory,
    purchaseOrders,
    suppliers,
    stockTransfers,
    dispenseRequests,
    doctorPrescriptions,
    pharmacy,
    bookPatients,
    salaryDoctorsReport,
  };
